import client from '../../shared/api/client';
import {
  ExchangeRateRecord,
  PaginatedResponse,
  SwapOperation,
  SwapSettings,
  SwapStatus,
} from '../../shared/types';

interface SwapBackendResponse<T> {
  success?: boolean;
  status?: string;
  data: T;
}

export interface SwapFilters {
  page?: number;
  per_page?: number;
  user_id?: string | number;
  status?: SwapStatus;
  from_currency?: string;
  to_currency?: string;
  reference_id?: string;
}

export const listSwaps = async (
  filters: SwapFilters = {}
): Promise<PaginatedResponse<SwapOperation>> => {
  const params: Record<string, string | number | undefined> = {
    page: filters.page ?? 1,
    per_page: filters.per_page ?? 20,
  };
  if (filters.user_id) params.user_id = filters.user_id;
  if (filters.status) params.status = filters.status;
  if (filters.from_currency) params.from_currency = filters.from_currency;
  if (filters.to_currency) params.to_currency = filters.to_currency;
  if (filters.reference_id) params.reference_id = filters.reference_id;

  const response = await client.get<SwapBackendResponse<PaginatedResponse<SwapOperation>>>(
    '/swap',
    { params }
  );
  return response.data.data;
};

export const getSwap = async (id: number): Promise<SwapOperation> => {
  const response = await client.get<SwapBackendResponse<SwapOperation>>(`/swap/${id}`);
  return response.data.data;
};

export const listExchangeRates = async (): Promise<ExchangeRateRecord[]> => {
  const response = await client.get<SwapBackendResponse<ExchangeRateRecord[]>>('/swap/rates');
  return response.data.data;
};

export const updateExchangeRate = async (
  currency: string,
  usdRate: number
): Promise<ExchangeRateRecord> => {
  const response = await client.put<SwapBackendResponse<ExchangeRateRecord>>(
    `/swap/rates/${currency}`,
    { usd_rate: usdRate }
  );
  return response.data.data;
};

export const getSwapSettings = async (): Promise<SwapSettings> => {
  const response = await client.get<SwapBackendResponse<SwapSettings>>('/swap/settings');
  return response.data.data;
};

export const updateSwapSettings = async (
  payload: Partial<Pick<SwapSettings, 'enabled_currencies' | 'currency_fees' | 'require_verification'>>
): Promise<SwapSettings> => {
  const response = await client.put<SwapBackendResponse<SwapSettings>>(
    '/swap/settings',
    payload
  );
  return response.data.data;
};
